import { Tooltip } from '@patrianna/core-components'
import { getTranslationFromJson } from '@patrianna/shared-utils/prismic'
import { InformationOutline } from '@patrianna-icons/material-icons'
import cx from 'classnames'

import content from 'prismic-translates/page-vip.json'

import classes from './styles.module.scss'

const t = getTranslationFromJson([content])

function VIPTable() {
  return (
    <div className={classes.tableContainer}>
      <table>
        <thead>
          <tr>
            <th>
              <p className={cx('mt-typography-body2', classes.caption)}>{t('benefit')}</p>
            </th>
            <th>
              <p className={cx('mt-typography-body2 mt-typography-alignCenter', classes.caption)}>{t('bronze')}</p>
            </th>
            <th>
              <p className={cx('mt-typography-body2 mt-typography-alignCenter', classes.caption)}>{t('silver')}</p>
            </th>
            <th>
              <p className={cx('mt-typography-body2 mt-typography-alignCenter', classes.caption)}>{t('gold')}</p>
            </th>
            <th>
              <p className={cx('mt-typography-body2 mt-typography-alignCenter', classes.caption)}>{t('platinum')}</p>
            </th>
            <th>
              <p className={cx('mt-typography-body2 mt-typography-alignCenter', classes.caption)}>{t('diamond')}</p>
            </th>
            <th>
              <p className={cx('mt-typography-body2 mt-typography-alignCenter', classes.caption)}>
                {t('royal_diamond')}
              </p>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <p className={cx('mt-typography-body2', classes.captionRow, classes.captionCell)}>
                {t('gold_coin')} <br /> {t('packages')}
                <Tooltip className={classes.toolTip} title={t('tooltip_gold')}>
                  <InformationOutline className={classes.cellInfo} />
                </Tooltip>
              </p>
            </td>
            <td>
              <p className='mt-typography-body2 mt-typography-alignCenter'>
                <b>{t('gold_coin_bronze_x')}</b>
              </p>
            </td>
            <td>
              <p className='mt-typography-body2 mt-typography-alignCenter'>
                <b>{t('gold_coin_silver_x')}</b>
              </p>
            </td>
            <td>
              <p className='mt-typography-body2 mt-typography-alignCenter'>
                <b>{t('gold_coin_gold_x')}</b>
              </p>
            </td>
            <td>
              <p className='mt-typography-body2 mt-typography-alignCenter'>
                <b>{t('gold_coin_platinum_x')}</b>
              </p>
            </td>
            <td>
              <p className='mt-typography-body2 mt-typography-alignCenter'>
                <b>{t('gold_coin_diamond_x')}</b>
              </p>
            </td>
            <td>
              <p className='mt-typography-body2 mt-typography-alignCenter'>
                <b>{t('gold_coin_royal_diamond_x')}</b>
              </p>
            </td>
          </tr>
          <tr>
            <td>
              <p className={cx('mt-typography-body2', classes.captionRow, classes.captionCell)}>
                {t('vip_points')} <br /> {t('level_up')}
                <Tooltip className={classes.toolTip} title={t('tooltip_vip')}>
                  <InformationOutline className={classes.cellInfo} />
                </Tooltip>
              </p>
            </td>
            <td>
              <p className='mt-typography-body2 mt-typography-alignCenter'>
                <b>{t('vip_points_bronze_x')}</b>
              </p>
            </td>
            <td>
              <p className='mt-typography-body2 mt-typography-alignCenter'>
                <b>{t('vip_points_silver_x')}</b>
              </p>
            </td>
            <td>
              <p className='mt-typography-body2 mt-typography-alignCenter'>
                <b>{t('vip_points_gold_x')}</b>
              </p>
            </td>
            <td>
              <p className='mt-typography-body2 mt-typography-alignCenter'>
                <b>{t('vip_points_platinum_x')}</b>
              </p>
            </td>
            <td>
              <p className='mt-typography-body2 mt-typography-alignCenter'>
                <b>{t('vip_points_diamond_x')}</b>
              </p>
            </td>
            <td>
              <p className='mt-typography-body2 mt-typography-alignCenter'>
                <b>{t('vip_points_royal_diamond_x')}</b>
              </p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}

export default VIPTable
